export default "__VITE_ASSET__DH0DN1EM__"